import React, { useState, useEffect } from 'react'
import { withRouter, NavLink } from 'react-router-dom'
import { newFetch, GET } from '../../../helpers/fetch'
import MUIDataTable from "mui-datatables";
import moment from 'moment';
import { makeStyles } from "@mui/styles";
import classNames from "classnames";
import { config } from '../../../config/index'
const { API_URL, SERVER_URL } = config

const useStyles = makeStyles({
    NameCell: {
      fontWeight: 900,
    },
  });
const ArtTest = () => {
    const classes = useStyles();
    const [data,setData] = useState([])
    const options = {
        selectableRows: false,
        download: true,
        print: false,
        sort: true,
        viewColumnss: true,
        rowsPerPage: 100,
        downloadOptions: { 
          filename: 'ART-Results.csv',
        },
      };
    const columns = [
    {
      name: "employee_id",
      label: "Employee ID",
      options: {
        filter: false,
        sort: true,
        setCellHeaderProps: (value) => {
          return {
            className: classNames({
              [classes.NameCell]: true,
            }),
          };
        },
      },
    },
    {
      name: "name",
      label: "Name",
      options: {
        filter: false,
        sort: true,
        setCellHeaderProps: (value) => {
          return {
            className: classNames({
              [classes.NameCell]: true,
            }),
          };
        },
      },
    },
    {
      name: "clientName",
      label: "Client",
      options: {
        filter: false,
        sort: false,
        setCellHeaderProps: (value) => {
          return {
            className: classNames({
              [classes.NameCell]: false,
            }),
          };
        },
      },
    },
    {
        name: "site",
        label: "Site",
        options: {
          filter: true,
          sort: true,
          setCellHeaderProps: (value) => {
            return {
              className: classNames({
                [classes.NameCell]: true,
              }),
            };
          },
        },
      },
      {
        name: "shift",
        label: "Shift",
        options: {
          filter: false,
          sort: false,
          setCellHeaderProps: (value) => {
            return {
              className: classNames({
                [classes.NameCell]: false,
              }),
            };
          },
        },
      },
      {
        name: "art_result",
        label: "ART",
        options: {
          filter: false,
          sort: false,
          customBodyRender:(value,tableMeta, updatedValue) =>{
            value = value.split('||')
            value[1] = `${SERVER_URL}/${value[1]}`
            return(
                <a href={value[1]} target='_blank'>{value[0]}</a>
            )
          },
          setCellHeaderProps: (value) => {
            return {
              className: classNames({
                [classes.NameCell]: false,
              }),
            };
          },
        },
      },
      {
        name: "test_result",
        label: "Result",
        options: {
          filter: false,
          sort: false,
          setCellHeaderProps: (value) => {
            return {
              className: classNames({
                [classes.NameCell]: false,
              }),
            };
          },
        },
      },
      {
        name: "date_submitted",
        label: "Date Submitted",
        options: {
          filter: false,
          sort: true,
          setCellHeaderProps: (value) => {
            return {
              className: classNames({
                [classes.NameCell]: true,
              }),
            };
          },
        },
      }
    ]

    const fetchArt = async () => {
        let api_path = `/admin/art/all`
        let response = await newFetch(GET, api_path)
        if(response.success){
           let data = []
           response.data.forEach((e)=>{
            let dataObj = {}
            let site =''
            let clientName =''
            if (e.associate !== null && e.associate !== undefined) {
                dataObj.name = e.associate.first_name
                e.associate.sites.forEach((element)=>{
                    site = site.concat(element.name)
                    clientName = element.client.name
                    if(e.associate.sites.length>1){
                  site = site.concat(', ')}
                })
                dataObj.site= site
                dataObj.shift = e.shift
                dataObj.employee_id = e.associate.employee_id
                dataObj.date_submitted = moment(e.createdAt).format('DD/MM/YYYY HH:MM');
                dataObj.test_result = e.result
                dataObj.clientName = clientName
                if (e.orig_image.length > 25) {
                  e.orig_image = `${e.orig_image.substr(0, 25)}...`
                }
                dataObj.art_result = dataObj.art_result = `${e.orig_image}||${e.image}`
                data =  data.concat(dataObj)
            }
           })
           setData(data)
        }
      
    }
    useEffect(()=>{
        fetchArt()
    },[])
return(
    <React.Fragment>
      <div className='art-wrapper'>
        <MUIDataTable
          title={"ART Results"}
          data={data}
          columns={columns}
          options={options}
        />
      </div> 
    </React.Fragment>
)


}


export default withRouter(ArtTest)